export default __webpack_public_path__ + "static/media/Attendance_line.d7e84f5c.svg";